export default __webpack_public_path__ + "static/media/doctor-side.c250610d.png";